import React from 'react';
import { withRouter } from 'react-router';
import LocalizedStrings from 'react-localization';
import { findByLabelText } from "@testing-library/react";
// import RatingStars from './RatingStars';
import Swiper from 'react-id-swiper';

function InsuranceItem(props) {
  const handleRedirect = () => {
    // window.gtag('event', 'click', { 'event_category': 'button-list-Детальніше' });
    props.history.push({
      pathname: props.locale === 'ua' ? '/uk/kasko/info' : '/kasko/info',
      search: `${props.location.search}&id=${props.id}`,
    });
  };

  const strings = new LocalizedStrings({
    ru: {
      get: 'Получи',
      cashback: 'кешбэка',
      sale: 'акция',
      promo: 'по Промокоду',
      polis: 'Полис',
      mark: 'оценок',
      reviews: 'Отзывы о компании',
      more: 'Подробнее',
      franchiseDamage: 'повреждения',
      franchiseStealing: 'угон'
    },
    ua: {
      get: 'Отримай ',
      cashback: 'кешбеку',
      sale: 'акція',
      promo: 'за промокодом',
      polis: 'Поліс',
      mark: 'оцінок',
      reviews: 'Відгуки про компанію',
      more: 'Детальніше',
      franchiseDamage: 'пошкодження',
      franchiseStealing: 'викрадення'
    },
  });

  strings.setLanguage(props.locale);

  // params for Swiper
  const params = {
    slidesPerView: 'auto',
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
    }
  }

  return (
    <div className="kasco_offer-item">
      {/* {props.with_cashback.status === true
        && (
          <div className="action-block flex flex_j-space-between">
            <div className="flex">
              <div className="tit">{strings.sale}</div>
              <h2>{strings.get} <span className="color-blue">10% {strings.cashback}</span> {strings.promo} «ALFA»</h2>
            </div>
            <div className="date">до {props.with_cashback.date}</div>
          </div>
        )} */}
      <div className="row">
        <div className="company">

          {/* logo */}
          <div className="logo-company">
            <picture>
              <source type="image/webp" srcSet={props.logoList[1]} />
              <img src={props.logoList[0]} alt={props.name} />
            </picture>
          </div>
          {/* End logo */}

          <div className="mob-tit">
            <div className="tit">{strings.polis} {props.type}</div>
            <h2>{props.name}</h2>
          </div>

          {/* rating */}
          {/* <div className="rating">
            <p>Рейтинг МТСБУ</p>
            <div className="flex">
              <RatingStars mark={props.mark} />
              <p>{props.mark} <a href="#/">({props.marks_count} {strings.mark})</a></p>
            </div>
            <a href="#/" className="review-company">{strings.reviews} <span>({props.reviews})</span></a>
          </div> */}
          {/* End rating */}

        </div>
        <div className="company-info">
          <div className="tit">{strings.polis} {props.type}</div>
          <h2>{props.name}</h2>
          <div className="company-tariff flex">
            <Swiper {...params}>
              {props.packages.map((item, id) => (
                <div className="tariff-item" key={id}>
                  <div className="txt">
                    <h3 className="company-name">«{item.name}»</h3>
                    <div className={item.amountWithDiscount ? "price-old" : "price"}>{Math.floor(item.amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} грн</div>
                    {item.amountWithDiscount && <div className="price">{Math.floor(item.amountWithDiscount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} грн</div>}
                  </div>
                  <div className="table">
                    <div className="table-row">
                      <span>Тариф</span>
                      <span>{item.tarif}%</span>
                    </div>
                    <div className="table-row">
                      <span>Франшиза <br /> ({strings.franchiseDamage})</span>
                      <span>{item.dtpFranchise}%</span>
                    </div>
                    <div className="table-row">
                      <span>Франшиза <br /> ({strings.franchiseStealing})</span>
                      <span>{item.ugonFranchise}%</span>
                    </div>
                  </div>
                  <button onClick={handleRedirect} type="button" className="btn">{strings.more}
                    <svg width={6} height={10} viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L5 5L1 9" stroke="#374656" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </div>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>

  );
}

export default withRouter(InsuranceItem);
